import React from "react";
import { useState } from "react";
import { Input, Button } from "@material-ui/core";
import { db, auth } from "../firebase";
import firebase from "firebase/compat/app";

function SendMessage({ scroll }) {
  const [msg, setMsg] = useState("");

  async function sendMessage(e) {
    e.preventDefault();
    const { uid, photoURL } = auth.currentUser;
    //destructuring auth.currentUser to get the user's id and photo
    await db.collection("messages").add({
      text: msg,
      photoURL,
      uid,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(), //using firebase.firestore.FieldValue to get the current time and order the messages by time
    }); //user object with id and photoURL
    setMsg(""); //clear the input field
    scroll.current.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div>
      <form onSubmit={sendMessage}>
        <div className="sendMsg">
          <Input
            style={{
              width: "100%",
              fontSize: "15px",
              fontWeight: "550",
              marginLeft: "5px",

              marginBottom: "-3px",
            }}
            placeholder="Message..."
            type="text"
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
          />
          <Button
            style={{
              width: "18%",
              fontSize: "15px",
              fontWeight: "550",
              margin: "4px 5% -13px 5%",
              maxWidth: "200px",
            }}
            type="submit"
          >
            Send
          </Button>
        </div>
      </form>
    </div>
  );
}

export default SendMessage;
